import Vue from "vue";
import VueI18n from "vue-i18n";
import cs from "./cs.json";
import da from "./da.json";
import de from "./de.json";
import el from "./el.json";
import enGB from "./en-GB.json";
import es from "./es.json";
import fi from "./fi.json";
import fr from "./fr.json";
import frCA from "./fr-CA.json";
import id from "./id.json";
import it from "./it.json";
import ms from "./ms.json";
import nl from "./nl.json";
import no from "./no.json";
import pl from "./pl.json";
import ptPT from "./pt-PT.json";
import ro from "./ro.json";
import sv from "./sv.json";
import tr from "./tr.json";
import zhTW from "./zh-TW.json";

Vue.use(VueI18n);

export default new VueI18n({
  locale: "en",
  fallbackLocale: {
    default: ["en-gb"],
  },
  messages: {
    "cs": cs,
    "da": da,
    "de": de,
    "en-gb": enGB,
    "el": el,
    "es": es,
    "fi": fi,
    "fr": fr,
    "fr-ca": frCA,
    "id": id,
    "it": it,
    "ms": ms,
    "nl": nl,
    "no": no,
    "pl": pl,
    "pt-pt": ptPT,
    "ro": ro,
    "sv": sv,
    "tr": tr,
    "zh-tw": zhTW,
  },
});
